import { useMemo, useState } from 'react'

import { CostCentersByLegalEntitiesDocument } from 'generated/resources/graphql'
import { debounce } from 'lodash'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

export interface CostCenterOption {
  id: string
  name: string
}

interface Props {
  legalEntityIds: number[]
  excludeCostCenterIds: number[]
}

export const useCostCenterByLegalEntities = ({ excludeCostCenterIds, legalEntityIds }: Props) => {
  const [search, setSearch] = useState('')
  const debouncedOnSearch = useMemo(
    () =>
      debounce((val) => {
        setSearch(val)
      }, 200),
    []
  )

  const { nodes, controls } = usePaginatedQuery(CostCentersByLegalEntitiesDocument, {
    variables: {
      legalEntityIds,
      search,
    },
    extractConnection: (data) => data.finance.costCentersConnection,
  })

  const costCenterOptions: CostCenterOption[] = nodes.map(
    (node): CostCenterOption => ({ id: `${node.id}`, name: node.name })
  )

  const filteredCostCenterOptions = costCenterOptions.filter(
    (op) => !excludeCostCenterIds.includes(Number(op.id))
  )

  return {
    controls,
    rawCostCenterOptions: costCenterOptions,
    debouncedOnSearch,
    filteredCostCenterOptions,
  }
}
